var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55785 13.3582L8.94075 7.45001C9.20969 7.20131 9.20969 6.7995 8.94075 6.55015L2.55785 0.641932C2.16961 0.282116 1.53794 0.282116 1.149 0.641932C0.760761 1.00175 0.760761 1.58572 1.149 1.94554L6.60923 7.0004L1.149 12.054C0.760761 12.4144 0.760761 12.9984 1.149 13.3582C1.53794 13.718 2.16961 13.718 2.55785 13.3582Z",
    fill: "#A1A4AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3b730fa0.svg";
export { ForwardRef as ReactComponent };